import { BasicTabState } from "./basic-tab-state";
import { IDocumentModel } from "./../../interfaces/document-model";
import { prop } from "../../../decorators/property";
import { ITabDefinition } from "../../interfaces/tab-definition";
import { TabViewDictionary } from "./../../helpers/tab-view-dictionary";

export class GenericTabModel extends Backbone.AssociatedModel {

    @prop() public Active = false;
    @prop() public PanelName: string;
    @prop() public Identifier: string;
    @prop() public Title: string;
    @prop() public Data: IDocumentModel;
    @prop() public Description: string;
    @prop() public ViewTypeName: string;
    @prop() public ItemViewTypeName: string;
    @prop() public State: BasicTabState = new BasicTabState();
    @prop() public Template: string;
    @prop() public TemplateName: string;
    @prop() public ChildTemplate: string;
    @prop() public DisableIfFalsey: string;
    @prop() public Source: string;

    public constructor(properties: ITabDefinition, data: IDocumentModel) {
        super();
        this.set(properties);
        if (properties.ChildView) {
            this.ItemViewTypeName = properties.ChildView.ViewTypeName;
            this.ChildTemplate = properties.ChildView.ViewTemplateName;
        }
        this.setDocumentData(data);
    }

    public setDocumentData(data: IDocumentModel): void {
        this.Data = data;
    }

    public refresh(data: IDocumentModel): void {
        this.Data = data;
    }

    public get TitleHtml(): string {
        const disabledString = this.Enabled ? "" : "disabled";
        return `<li>
            <a href="javascript:;" class="section-button ${this.Identifier} ${disabledString}" ${!this.Enabled ? "aria-disabled=\"true\"" : ""}  data-panel="${this.PanelName}" data-section="${this.Identifier}" title="${this.Description}">
                ${this.Title}
            </a>
        </li>`;
    }

    public get Enabled() {
        if (this.DisableIfFalsey) {
            if (!this.Data.get(this.DisableIfFalsey)) {
                return false;
            }
        }

        return true;
    }

    public get ViewType() {
        const v = TabViewDictionary[this.ViewTypeName];
        if (!v) {
            // tslint:disable-next-line
            console.error("No view found for the ViewTypeName: " + this.ViewTypeName + " - did you add an entry to the tab view dictionary?");
        }
        return v;
    }

    public get ItemViewType() {
        const iv = TabViewDictionary[this.ItemViewTypeName];
        if (!iv) {
            // tslint:disable-next-line
            console.error("No view found for the ItemViewTypeName: " + this.ItemViewTypeName + " - did you add an entry to the tab view dictionary?");
        }
        return iv;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/generic-tab.ts